// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2173":"d024ae08","3442":"681920a4","8418":"4d93f037","9973":"2abfb773"}[chunkId] + ".chunk.css";
};